module.exports = __webpack_public_path__ + "static/media/C_9.f495d7ad.png";